import moment from 'moment';
import {
  ETAT_COMMANDE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_ENREGISTRE,
  ETAT_ENATTENTE,
} from '@/configuration/devisConf';
import { DATES_RENOUVELLEMENT } from '@/configuration/commande/commandeConf';

export default function
genererCriteresRechercheRenouvellementCommande(paramMedialinePlanningLCRenouvellement = false) {
  return {
    auto: null,
    commercialId: null,
    assistantIds: null,
    etatsRenouvellement: paramMedialinePlanningLCRenouvellement ? [ETAT_ENATTENTE] : [],
    dates: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: paramMedialinePlanningLCRenouvellement
        ? (moment().add(5, 'months').endOf('month')).toDate() : (moment().endOf('month')).toDate(),
    },
    societeId: null,
    sens: null,
    etat: [
      ETAT_FACTURE_PARTIELLEMENT,
      ETAT_FACTURE,
      ETAT_COMMANDE,
      ETAT_ENREGISTRE,
    ],
    code: null,
    codeDossier: null,
    annonceur: null,
    payeur: null,
    optionDate: DATES_RENOUVELLEMENT,
    groupeIds: [],
    enseigneIds: [],
    agencesId: [],
    themes: [],
    annonceurs: [],
    payeurs: [],
    interne: false,
    tagIds: [],
    dateCampagne: {
      dateDebut: null,
      dateFin: null,
    },
    reconductible: null,
    estSigne: null,
    estSigneElectroniquement: null,
  };
}
